import React from 'react';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { EButtonType } from '../BaseConfirmDialog/BaseConformationDialog.types';

export const renderReportDialog = (data) => openPopupHelper({ popupName: popupNames.REPORT_DIALOG, data });
export const closeReportDialog = () => closePopupHelper(popupNames.REPORT_DIALOG);

export const modalContent = {
    renderHeader: () => <>Пожаловаться на файл</>,
    renderContent: () => (
        <>
            Проверим файл и удалим файл из <b>Доступных мне</b> — восстановить его уже не получится
        </>
    ),
    buttons: [EButtonType.accept, EButtonType.cancel],
};
